export const sortByPaymentMethodLength = (a, b) => {
  return a[0].length > b[0].length ? 1 : -1
}
